import { TugReleasedData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const TUG_RELEASED_DATA_TAG = 'TugReleasedData';
export default class TugReleasedParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.TUG_RELEASED, FIXED_PROTOCOL_CONTENT_TYPE_IDS.TUG_RELEASED, TUG_RELEASED_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new TugReleasedData(props.name, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.name,
            };
            data.name = link;
        }
        return data;
    }
}
//# sourceMappingURL=TugReleasedParser.js.map